module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3n2r6n9r-e41b8258ea7491b0737687bb3a0b6fdf.svg";